import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { formatDate } from '../utils/formatDate';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import { API_URL } from '../config';

const BlogDetail = () => {
  const { id } = useParams();
  console.log('Blog ID:', id);
  
  const [blog, setBlog] = useState(null);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Fetching blog data for ID:', id);
        // Ana blog yazısını getir
        const blogResponse = await axios.get(
          `${API_URL}/api/blogs?filters[id][$eq]=${id}&populate=*`
        );
        
        console.log('Full Blog Response:', blogResponse);
        console.log('Blog Response Data:', blogResponse.data);
        console.log('Blog Response Data Length:', blogResponse.data?.data?.length);
        
        if (blogResponse.data?.data?.length > 0) {
          const blogData = blogResponse.data.data[0];
          console.log('Raw Blog Data:', blogData);
          
          const currentBlog = {
            id: blogData.id,
            title: blogData.title || 'Başlık Bulunamadı',
            content: blogData.content || 'İçerik Bulunamadı',
            createdAt: blogData.createdAt || new Date().toISOString(),
            image: null,
            category: null
          };

          // Image handling
          if (blogData.image?.url) {
            currentBlog.image = `${API_URL}${blogData.image.url}`;
          }

          // Category handling
          if (blogData.category) {
            currentBlog.category = {
              id: blogData.category.id,
              name: blogData.category.name,
              slug: blogData.category.slug
            };
          }
          
          console.log('Transformed Current Blog:', currentBlog);
          setBlog(currentBlog);
          
          // Son yazıları getir
          const recentResponse = await axios.get(
            `${API_URL}/api/blogs?populate=*&sort[0]=createdAt:desc&pagination[limit]=5`
          );
          console.log('Recent Response:', recentResponse.data);
          const filteredRecentBlogs = recentResponse.data.data.filter(
            blog => blog.id.toString() !== id
          ).map(blog => {
            console.log('Processing Recent Blog:', blog);
            const recentBlog = {
              id: blog.id,
              title: blog.title || 'Başlık Bulunamadı',
              content: blog.content || 'İçerik Bulunamadı',
              createdAt: blog.createdAt || new Date().toISOString(),
              image: null,
              category: null
            };

            // Image handling
            if (blog.image?.url) {
              recentBlog.image = `${API_URL}${blog.image.url}`;
            }

            // Category handling
            if (blog.category) {
              recentBlog.category = {
                id: blog.category.id,
                name: blog.category.name,
                slug: blog.category.slug
              };
            }

            return recentBlog;
          });
          console.log('Transformed Recent Blogs:', filteredRecentBlogs);
          setRecentBlogs(filteredRecentBlogs);

          // Benzer yazıları getir (aynı kategorideki)
          const currentCategoryId = currentBlog.category?.id;
          console.log('Current Category ID:', currentCategoryId);
          
          if (currentCategoryId) {
            const relatedResponse = await axios.get(
              `${API_URL}/api/blogs?populate=*&filters[category][id][$eq]=${currentCategoryId}&filters[id][$ne]=${id}&pagination[limit]=3`
            );
            console.log('Related Response:', relatedResponse.data);
            const transformedRelatedBlogs = relatedResponse.data.data.map(blog => {
              console.log('Processing Related Blog:', blog);
              const relatedBlog = {
                id: blog.id,
                title: blog.title || 'Başlık Bulunamadı',
                content: blog.content || 'İçerik Bulunamadı',
                createdAt: blog.createdAt || new Date().toISOString(),
                image: null,
                category: null
              };

              // Image handling
              if (blog.image?.url) {
                relatedBlog.image = `${API_URL}${blog.image.url}`;
              }

              // Category handling
              if (blog.category) {
                relatedBlog.category = {
                  id: blog.category.id,
                  name: blog.category.name,
                  slug: blog.category.slug
                };
              }

              return relatedBlog;
            });
            console.log('Transformed Related Blogs:', transformedRelatedBlogs);
            setRelatedBlogs(transformedRelatedBlogs);
          }
        } else {
          console.error('Blog data not found in response');
          setError('Blog yazısı bulunamadı.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        console.error('Error response:', error.response);
        console.error('Error message:', error.message);
        setError('Veriler yüklenirken bir hata oluştu.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  const BlogCard = ({ blog, isSmall }) => (
    <Link 
      to={`/blog/${blog.id}`} 
      className="block h-full"
      onClick={() => window.scrollTo(0, 0)}
    >
      <div className={`bg-white rounded-lg transition-all duration-300 h-full flex flex-col ${isSmall ? 'hover:bg-gray-50' : 'shadow-md hover:shadow-lg'}`}>
        {blog?.image && (
          <img
            src={blog.image}
            alt={blog?.title}
            className={`w-full rounded-t-lg ${isSmall ? 'h-32' : 'h-48'} object-cover`}
          />
        )}
        <div className="p-4 flex flex-col flex-grow">
          {blog?.category?.name && (
            <span className="inline-block px-2 py-0.5 text-xs font-medium text-primary bg-primary/10 rounded-full mb-2 w-fit">
              {blog.category.name}
            </span>
          )}
          <h3 className={`font-bold ${isSmall ? 'text-sm' : 'text-lg'} mb-2 line-clamp-2 group-hover:text-primary`}>
            {blog?.title}
          </h3>
          <p className={`text-gray-600 ${isSmall ? 'text-sm' : 'text-base'} mb-2 line-clamp-2`}>
            {blog?.content}
          </p>
          <div className="text-sm text-gray-500 mt-auto">
            {formatDate(blog?.createdAt)}
          </div>
        </div>
      </div>
    </Link>
  );

  // Reading time hesaplama fonksiyonu
  const calculateReadingTime = (text) => {
    const wordsPerMinute = 200;
    const words = text?.trim().split(/\s+/).length || 0;
    const minutes = Math.ceil(words / wordsPerMinute);
    return `${minutes} dakika okuma`;
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
          Blog yazısı yükleniyor...
        </div>
      </div>
    );
  }

  console.log('Rendering blog:', blog);
  const readingTime = calculateReadingTime(blog?.content);

  return (
    <div className="min-h-screen bg-gray-50 pt-24">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Ana İçerik */}
          <div className="lg:col-span-2">
            {/* Blog Başlığı ve Meta Bilgiler */}
            <div className="mb-8">
              <h1 className="text-4xl font-bold text-gray-900 mb-4">
                {blog?.title}
              </h1>

              {blog?.category?.name && (
                <span className="inline-block px-1 py-0.5 text-sm font-medium text-primary bg-primary/10 rounded-full mb-4 w-fit">
                  {blog.category.name}
                </span>
              )}

              <div className="flex items-center text-gray-600 text-sm space-x-4">
                <div className="flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  {formatDate(blog?.createdAt)}
                </div>
                <div className="flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  {readingTime}
                </div>
              </div>
            </div>

            {/* Blog Görseli */}
            {blog?.image && (
              <div className="mb-8">
                <img
                  src={blog.image}
                  alt={blog?.title || 'Blog görseli'}
                  className="w-full h-auto rounded-lg shadow-md"
                />
              </div>
            )}

            {/* Blog İçeriği */}
            <div className="prose max-w-none text-gray-800">
              <ReactMarkdown>{blog?.content || ''}</ReactMarkdown>
            </div>

            {/* Benzer Yazılar */}
            {relatedBlogs.length > 0 && (
              <div className="mt-12 pt-8 border-t border-gray-200">
                <h2 className="text-2xl font-bold mb-6">Benzer Yazılar</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                  {relatedBlogs.map((blog) => (
                    <Link 
                      key={blog.id} 
                      to={`/blog/${blog.id}`} 
                      className="group h-full"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      <div className="border-2 border-gray-200 rounded-lg hover:border-primary transition-colors duration-300 h-full flex flex-col overflow-hidden">
                        {blog.image && (
                          <div className="h-48 overflow-hidden flex-shrink-0">
                            <img
                              src={blog.image}
                              alt={blog.title}
                              className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                            />
                          </div>
                        )}
                        <div className="p-6 flex flex-col flex-grow">
                          {blog?.category?.name && (
                            <span className="inline-block px-2 py-0.5 text-xs font-medium text-primary bg-primary/10 rounded-full mb-2 w-fit">
                              {blog.category.name}
                            </span>
                          )}
                          <h3 className="text-xl font-semibold mb-2 group-hover:text-primary transition-colors line-clamp-2">
                            {blog.title}
                          </h3>
                          <p className="text-gray-600 mb-4 line-clamp-2">
                            {blog.content}
                          </p>
                          <div className="text-sm text-gray-500 mt-auto">
                            {formatDate(blog.createdAt)}
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Sağ Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">Son Yazılar</h2>
                <Link 
                  to="/blog" 
                  className="text-sm text-primary hover:text-primary/80 transition-colors font-medium"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Tümünü Gör
                </Link>
              </div>
              <div className="space-y-6">
                {recentBlogs.map((blog) => (
                  <div key={blog.id} className="group transition-all duration-300 hover:-translate-y-1">
                    <BlogCard blog={blog} isSmall={true} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
